import type { TweakState } from "../Tweaks";

export const TWEAK_DEFAULTS: TweakState = {
  mode: "light",
};

/** v2: default carta catastale (light). Resetta la preferenza dark SaaS precedente. */
export const TWEAK_STORAGE_KEY = "legacy-console-tweaks-v2";

export function parseStoredTweaks(raw: string | null): TweakState {
  if (!raw) return TWEAK_DEFAULTS;
  try {
    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return TWEAK_DEFAULTS;
    const stored = parsed as Record<string, unknown>;
    return {
      mode: stored.mode === "light" || stored.mode === "dark" ? stored.mode : TWEAK_DEFAULTS.mode,
    };
  } catch {
    return TWEAK_DEFAULTS;
  }
}

export function applyTweaksToDocument(tweaks: TweakState) {
  const root = document.documentElement;
  root.dataset.theme = tweaks.mode;
}
